import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    name: "Unnamed user",
    mood: ''
  },
  mutations: {
    setName (state,payload) {
      state.name = payload.name
    },
    setMood (state,payload) {
      state.mood = payload.mood
    },
  },
  actions: {
    setName ({commit},payload) {
      commit('setName',payload)
      Vue.prototype.$socket.emit('user update name', {name: payload.name})
    },
    setMood ({commit},payload) {
      commit('setMood',payload)
      if(payload.emit){
        Vue.prototype.$socket.emit('user update mood', {mood: payload.mood})
      }
    },
  },
}
